import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { 
  Shield,
  FileText,
  Users,
  Lock,
  AlertTriangle,
  Scale,
  Mail,
  ChevronRight
} from 'lucide-react';

const sections = [
  {
    id: 1,
    title: "Accettazione dei Termini",
    icon: FileText,
    content: `
      <p>Utilizzando la piattaforma Assietica Gest by Assietica, l'utente accetta integralmente i presenti Termini di Utilizzo.</p>
      <p>La registrazione e l'accesso alla piattaforma implicano la presa visione e l'accettazione delle condizioni qui descritte.</p>
      <p>Assietica Società Cooperativa – Società Benefit si riserva il diritto di modificare i presenti termini in qualsiasi momento, dandone comunicazione agli utenti registrati.</p>
    `
  },
  {
    id: 2,
    title: "Descrizione del Servizio",
    icon: Shield,
    content: `
      <p>Assietica Gest è una piattaforma SaaS (Software as a Service) progettata per aiutare gli enti del Terzo Settore nella gestione di:</p>
      <ul>
        <li>Anagrafica volontari</li>
        <li>Attività e presenze</li>
        <li>Documentazione amministrativa</li>
        <li>Rendicontazione economica e sociale</li>
        <li>Report e statistiche</li>
      </ul>
      <p>Il servizio è offerto in modalità freemium con piani gratuiti e a pagamento.</p>
    `
  },
  {
    id: 3,
    title: "Obblighi dell'Utente",
    icon: Users,
    content: `
      <p>L'utente si impegna a:</p>
      <ul>
        <li>Fornire informazioni veritiere durante la registrazione</li>
        <li>Mantenere riservate le proprie credenziali di accesso</li>
        <li>Utilizzare la piattaforma in conformità alla normativa vigente</li>
        <li>Non utilizzare il servizio per finalità illecite o contrarie all'ordine pubblico</li>
        <li>Rispettare la privacy dei dati inseriti relativi a volontari e terzi</li>
        <li>Non tentare di accedere in modo non autorizzato ai sistemi della piattaforma</li>
      </ul>
      <p>L'utente è responsabile dei dati inseriti nella piattaforma e garantisce di avere i diritti necessari per il loro trattamento.</p>
    `
  },
  {
    id: 4,
    title: "Privacy e Trattamento Dati",
    icon: Lock,
    content: `
      <p>Il trattamento dei dati personali avviene nel rispetto del Regolamento UE 2016/679 (GDPR) e della normativa italiana in materia di privacy.</p>
      <p>Titolare del trattamento è <strong>Assietica Società Cooperativa – Società Benefit</strong>.</p>
      <p>I dati inseriti nella piattaforma sono trattati esclusivamente per le finalità del servizio:</p>
      <ul>
        <li>Gestione dell'account utente</li>
        <li>Erogazione delle funzionalità della piattaforma</li>
        <li>Comunicazioni di servizio</li>
        <li>Assistenza tecnica</li>
      </ul>
      <p>L'utente, in qualità di titolare del trattamento dei dati dei propri volontari, è responsabile dell'acquisizione dei necessari consensi e dell'informativa agli interessati.</p>
      <p>Per informazioni complete sul trattamento dei dati, consultare l'Informativa Privacy disponibile sul sito.</p>
    `
  },
  {
    id: 5,
    title: "Limitazione di Responsabilità",
    icon: AlertTriangle,
    content: `
      <p>Assietica si impegna a garantire la continuità e la sicurezza del servizio, tuttavia:</p>
      <ul>
        <li>Non garantisce che il servizio sia esente da errori o interruzioni</li>
        <li>Non è responsabile per perdite di dati causate da eventi al di fuori del proprio controllo</li>
        <li>Non è responsabile per danni derivanti dall'uso improprio della piattaforma</li>
        <li>Non è responsabile per contenuti inseriti dagli utenti</li>
      </ul>
      <p>La responsabilità di Assietica è in ogni caso limitata all'importo corrisposto dall'utente per il servizio nei 12 mesi precedenti.</p>
      <p>Si consiglia agli utenti di effettuare regolarmente il backup dei propri dati tramite l'apposita funzionalità della piattaforma.</p>
    `
  },
  {
    id: 6,
    title: "Proprietà Intellettuale",
    icon: Scale,
    content: `
      <p>La piattaforma Assietica Gest, inclusi software, grafica, loghi e contenuti, è di proprietà esclusiva di Assietica Società Cooperativa – Società Benefit.</p>
      <p>All'utente è concessa una licenza d'uso non esclusiva e non trasferibile per la durata del contratto.</p>
      <p>È vietato:</p>
      <ul>
        <li>Copiare, modificare o distribuire parti della piattaforma</li>
        <li>Decompilare o effettuare reverse engineering del software</li>
        <li>Rimuovere o alterare marchi o indicazioni di copyright</li>
        <li>Utilizzare il marchio Assietica Gest senza autorizzazione scritta</li>
      </ul>
    `
  },
  {
    id: 7,
    title: "Sospensione e Cessazione",
    icon: AlertTriangle,
    content: `
      <p>Assietica si riserva il diritto di sospendere o terminare l'accesso alla piattaforma in caso di:</p>
      <ul>
        <li>Violazione dei presenti Termini di Utilizzo</li>
        <li>Uso improprio o fraudolento del servizio</li>
        <li>Mancato pagamento (per piani a pagamento)</li>
        <li>Richiesta dell'utente</li>
      </ul>
      <p>In caso di cessazione, l'utente avrà 30 giorni per scaricare i propri dati. Trascorso tale periodo, i dati potranno essere cancellati.</p>
      <p>L'utente può richiedere la cancellazione del proprio account in qualsiasi momento contattando il supporto.</p>
    `
  },
  {
    id: 8,
    title: "Legge Applicabile e Foro Competente",
    icon: Scale,
    content: `
      <p>I presenti Termini di Utilizzo sono regolati dalla legge italiana.</p>
      <p>Per qualsiasi controversia derivante dall'interpretazione o dall'esecuzione dei presenti termini, le parti si impegnano a tentare una composizione amichevole.</p>
      <p>In caso di mancato accordo, il Foro competente esclusivo sarà quello di Milano.</p>
    `
  },
  {
    id: 9,
    title: "Contatti",
    icon: Mail,
    content: `
      <p>Per qualsiasi informazione relativa ai presenti Termini di Utilizzo, è possibile contattare:</p>
      <ul>
        <li><strong>Assietica Società Cooperativa – Società Benefit</strong></li>
        <li>Email: <a href="mailto:supporto@assietica.it">supporto@assietica.it</a></li>
        <li>Sito web: <a href="https://www.assieticagest.it" target="_blank">www.assieticagest.it</a></li>
      </ul>
      <p>Ultimo aggiornamento: Marzo 2026</p>
    `
  }
];

export default function TerminiUtilizzo() {
  return (
    <div className="space-y-6" data-testid="termini-utilizzo-page">
      {/* Header */}
      <div className="text-center mb-8">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-[#0055BB]/10 rounded-full mb-4">
          <Scale className="w-8 h-8 text-[#0055BB]" />
        </div>
        <h1 className="text-3xl font-bold text-slate-900" style={{ fontFamily: 'Outfit, sans-serif' }}>
          Termini di Utilizzo
        </h1>
        <p className="text-slate-500 mt-2 max-w-2xl mx-auto">
          Condizioni generali per l'utilizzo della piattaforma Assietica Gest <span className="italic">by Assietica</span>
        </p>
      </div>

      {/* Intro Card */}
      <Card className="bg-amber-50 border-amber-200">
        <CardContent className="py-4">
          <div className="flex items-start gap-3">
            <AlertTriangle className="w-5 h-5 text-amber-600 mt-0.5 flex-shrink-0" />
            <div>
              <p className="text-sm text-amber-800 font-medium">
                Importante
              </p>
              <p className="text-sm text-amber-700">
                L'utilizzo della piattaforma implica l'accettazione integrale dei presenti termini. 
                Si prega di leggere attentamente prima di procedere.
              </p>
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Sections */}
      <div className="space-y-4">
        {sections.map((section) => {
          const IconComponent = section.icon;
          
          return (
            <Card key={section.id}>
              <CardHeader>
                <CardTitle className="flex items-center gap-4">
                  <span className="flex items-center justify-center w-10 h-10 bg-[#0055BB] text-white rounded-full font-bold text-sm">
                    {section.id}
                  </span>
                  <div className="flex items-center gap-3">
                    <IconComponent className="w-5 h-5 text-[#0055BB]" />
                    <span className="text-lg">{section.title}</span>
                  </div>
                </CardTitle>
              </CardHeader>
              <CardContent>
                <div 
                  className="prose prose-slate max-w-none
                    prose-headings:text-slate-800 prose-headings:font-semibold
                    prose-p:text-slate-600 prose-p:leading-relaxed prose-p:my-2
                    prose-ul:text-slate-600 prose-ul:my-3
                    prose-li:my-1
                    prose-a:text-[#0055BB] prose-a:no-underline hover:prose-a:underline
                    prose-strong:text-slate-800"
                  dangerouslySetInnerHTML={{ __html: section.content }}
                />
              </CardContent>
            </Card>
          );
        })}
      </div>

      {/* Footer */}
      <Card className="bg-gradient-to-br from-[#0055BB] to-[#003d88] text-white">
        <CardContent className="py-8 text-center">
          <Shield className="w-12 h-12 mx-auto mb-4 opacity-90" />
          <h3 className="text-xl font-bold mb-2">La tua sicurezza è la nostra priorità</h3>
          <p className="opacity-90 max-w-2xl mx-auto">
            Assietica si impegna a proteggere i tuoi dati e a fornirti un servizio affidabile e sicuro.
            Per qualsiasi domanda, non esitare a contattarci.
          </p>
        </CardContent>
      </Card>

      {/* Version info */}
      <div className="text-center text-xs text-slate-400 py-4">
        <p>© 2026 Assietica Società Cooperativa – Società Benefit. Tutti i diritti riservati.</p>
        <p>Versione documento: 1.0 - Ultimo aggiornamento: Marzo 2026</p>
      </div>
    </div>
  );
}
